import { TranslationKey } from '@/modules/i18n/types'
import { UserService } from '@duck/api-definitions'

export const getStatusBadgeColor = (status: UserService.InvitationStatusEnum): string => {
  const statusColors = {
    'active': 'bg-warning/10 text-warning border border-warning/20',
    'accepted': 'bg-accent/10 text-accent border border-accent/20',
    'expired': 'bg-warning/10 text-warning border border-warning/20',
    'revoked': 'bg-error/10 text-error border border-error/20',
  }
  return statusColors[status as keyof typeof statusColors] || 'bg-muted/10 text-muted border border-muted/20'
}


export const formatStatus = (status: UserService.InvitationStatusEnum, hasInvitationToken: boolean): TranslationKey => {
  const statusMap: Record<UserService.InvitationStatusEnum, TranslationKey> = {
    [UserService.InvitationStatusEnum.Active]: hasInvitationToken ? 'common.invitationCreated' : 'invitations.invited',
    [UserService.InvitationStatusEnum.Accepted]: 'invitations.accepted',
    [UserService.InvitationStatusEnum.Expired]: 'invitations.expired',
    [UserService.InvitationStatusEnum.Revoked]: 'invitations.revoked',
  }
  return statusMap[status] || 'common.na'
}

export interface Column {
  key: keyof UserService.Invitation | 'actions'
  label: TranslationKey
  sortable: boolean
  visible: boolean
}

export const baseColumns: Column[] = [
  { key: 'id', label: 'common.id', sortable: true, visible: false },
  { key: 'email', label: 'common.email', sortable: true, visible: true },
  { key: 'firstName', label: 'common.firstName', sortable: true, visible: true },
  { key: 'lastName', label: 'common.lastName', sortable: true, visible: true },
  { key: 'accessGroups', label: 'common.accessGroups', sortable: false, visible: true },
  { key: 'status', label: 'common.status', sortable: true, visible: true },
  { key: 'organizationId', label: 'common.organization', sortable: true, visible: false },
  { key: 'validFor', label: 'invitations.validFor', sortable: true, visible: false },
  { key: 'inviterId', label: 'invitations.inviterId', sortable: true, visible: false },
  { key: 'inviterName', label: 'invitations.inviterName', sortable: true, visible: true },
  { key: 'registeredUserId', label: 'common.registeredUserId', sortable: true, visible: false },
  { key: 'createdAt', label: 'common.createdAt', sortable: true, visible: true },
  { key: 'updatedAt', label: 'common.updatedAt', sortable: true, visible: false },
  { key: 'expiresAt', label: 'common.expiresAt', sortable: true, visible: true },
  { key: 'actions', label: 'common.actions', sortable: false, visible: true },
]
